import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Handle form submission - decide between VIN navigation or license plate submission
  handleSubmit(event) {
    event.preventDefault()
    
    const form = event.target
    const isSingle = form.querySelector('button[data-single]').dataset.single === 'true'
    
    // Check if any input group is in "selected" mode (license plate mode)
    const inputGroups = form.querySelectorAll('.input-group')
    const isLicensePlateMode = Array.from(inputGroups).some(group => group.classList.contains('selected'))
    
    if (isLicensePlateMode) {
      this.submitLicensePlate(form)
    } else {
      this.navigateWithVin(form, isSingle)
    }
  }
  
  // Navigate directly with VIN
  navigateWithVin(form, isSingle) {
    // Get VIN values
    const vin1 = form.querySelector('input[name="search[vin_numbers][]"]')?.value?.trim().toUpperCase()
    const vin2 = form.querySelector('input[id="vin_number_2"]')?.value?.trim().toUpperCase()

    // Validate VIN format (basic 17-character check)
    const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/

    if (!vin1 || !vinRegex.test(vin1)) {
      alert('Please enter a valid 17-character VIN')
      return
    }

    if (!isSingle && (!vin2 || !vinRegex.test(vin2))) {
      alert('Please enter a valid 17-character VIN for the second vehicle')
      return
    }

    // Show loading state
    const button = form.querySelector('button[type="submit"]')
    button.disabled = true
    button.innerHTML = button.dataset.originalMsg || 'Decoding....'

    // Navigate directly to results page
    let path
    if (isSingle) {
      path = `/decode/${vin1}`
    } else {
      path = `/vin_compare/${vin1}/${vin2}`
    }

    window.location.href = path
  }
  
  // Submit license plate data to the API
  submitLicensePlate(form) {
    // Get license plate data from the selected input group
    const selectedGroup = form.querySelector('.input-group.selected')
    if (!selectedGroup) {
      alert('Please enter license plate information')
      return
    }
    
    const plateInput = selectedGroup.querySelector('input[name^="plate_"]')
    const stateSelect = selectedGroup.querySelector('select[name^="state_"]')
    
    if (!plateInput?.value?.trim()) {
      alert('Please enter a license plate number')
      return
    }
    
    if (!stateSelect?.value) {
      alert('Please select a state')
      return
    }
    
    // Create hidden inputs for the license plate data
    this.addHiddenInput(form, 'license_plate', plateInput.value.trim())
    this.addHiddenInput(form, 'state', stateSelect.value)
    
    // Set form action for license plate endpoint and ensure Turbo handles it
    form.action = '/license_plate_data'
    form.method = 'post'
    
    // Get the CSRF token from the form
    const csrfToken = form.querySelector('input[name="authenticity_token"]')?.value
    
    // Use fetch with Turbo headers to ensure proper handling
    const formData = new FormData(form)
    
    fetch('/license_plate_data', {
      method: 'POST',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml',
        'X-CSRF-Token': csrfToken,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      // Find the turbo_modal frame and update it
      const modalFrame = document.getElementById('turbo_modal')
      if (modalFrame) {
        modalFrame.innerHTML = html
      }
    })
    .catch(error => {
      console.error('Error submitting license plate data:', error)
      alert('Error submitting license plate data. Please try again.')
    })
  }
  
  // Helper to add hidden input
  addHiddenInput(form, name, value) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  }
}
